import React from 'react';
import { Route } from 'react-router-dom';
import NavFooter from './NavComponents/NavFooter/NavFooter';
import NavMenu from './NavComponents/NavMenu/NavMenu';

const Layout = ({ children, ...rest }) => {
    return (
        <div className="d-flex flex-column">
            <NavMenu />
            {children}
            <NavFooter />
        </div>
    )
}

const RouteLayout = ({ component: Component, ...rest }) => {
    //todo: logic for validate user 

    return (
        <Route {...rest} render={matchProps => (
            <Layout>
                <Component {...matchProps} />
            </Layout>
        )} />
    )
};

export default RouteLayout;